import { IServiceRequestsState } from '../state';

export const trackingReducer = (state: IServiceRequestsState, action) => {
    return {
        ...state,
        trackingPageStates: {
            selectedTab: action.tabName
        }

    }
}
